module.exports = __webpack_public_path__ + "img/11_l_no.9e1eb9a1.svg";